/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneFrisbiiPayment as ResolvedStandaloneFrisbiiPayment } from 'base/components/standalone/FrisbiiPayment';

export const FrisbiiPayment: typeof ResolvedStandaloneFrisbiiPayment = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneFrisbiiPayment {...props} />
    );
});

export type FrisbiiPaymentProps = PropsFromComponent<typeof FrisbiiPayment>;

/** @deprecated Use slot architecture instead */
export const FrisbiiPaymentWith = (extras: DynamicStandaloneExtras): typeof FrisbiiPayment => {
    return function FrisbiiPayment(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'FrisbiiPayment');
        return <ResolvedStandaloneFrisbiiPayment {...mergeProps({ options: { theme } }, props)} />;
    }
}